import { __decorate } from "tslib";
import { Component, SecurityContext, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateObjectPipe } from '../../../pipes/translate-object.pipe';
/**
 * Contract Component
 */
let ContractComponent = class ContractComponent {
    constructor(httpClient, sanitizer, themeService, translateObjectPipe) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.translateObjectPipe = translateObjectPipe;
        this.notifications = {};
        this.contracts = [];
        this.saved = false;
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.accentColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
    }
    ngOnInit() {
        this.httpClient.get('template/gettemplate').subscribe((result) => {
            result['data'].sort(a => {
                if (a.status === 'ACCEPTED') {
                    return -1;
                }
            });
            this.contracts = result['data'];
        });
    }
    download(files, type) {
        var a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);
        files.forEach(file => {
            let download = this.sanitize(file.download);
            let extension = file.original_name.split('.').pop();
            a.setAttribute('href', download);
            a.setAttribute('download', (type === 'ugovor' ? this.translateObjectPipe.transform('ACCOUNT.CONTRACT') : this.translateObjectPipe.transform('ACCOUNT.DCA_ANNEX')) + '.' + extension);
            a.click();
        });
        document.body.removeChild(a);
    }
    sanitize(url) {
        return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    }
};
ContractComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: TranslateObjectPipe }
];
ContractComponent = __decorate([
    Component({
        selector: 'ecd-contract',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./contract.component.html")).default,
        providers: [TranslateObjectPipe]
    })
], ContractComponent);
export { ContractComponent };
